import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=db0de5f2"
import script from "@/controllers/ap/user/Add?vue&type=script&lang=ts&external"
export * from "@/controllers/ap/user/Add?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports